import { render, staticRenderFns } from "./assignmentform.vue?vue&type=template&id=10feca5e&"
import script from "./assignmentform.vue?vue&type=script&lang=js&"
export * from "./assignmentform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports